import { render, staticRenderFns } from "./PanelNavigation.vue?vue&type=template&id=fdf8d84c&scoped=true"
import script from "./PanelNavigation.vue?vue&type=script&lang=js"
export * from "./PanelNavigation.vue?vue&type=script&lang=js"
import style0 from "./PanelNavigation.vue?vue&type=style&index=0&id=fdf8d84c&prod&lang=css&scoped=true"
import style1 from "./PanelNavigation.vue?vue&type=style&index=1&id=fdf8d84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf8d84c",
  null
  
)

export default component.exports